const composeFontProperty = (values: Record<string, string | null>): string => {
  const { fontWeight, fontSize, fontFamily } = values;

  if (!fontWeight && !fontSize && !fontFamily) {
    return '';
  }

  const parts = [];

  if (fontWeight && fontWeight !== 'normal') {
    parts.push(fontWeight);
  }

  if (fontSize) {
    parts.push(fontSize);
  }

  if (fontFamily) {
    parts.push(fontFamily);
  }

  return parts.length > 0 ? parts.join(' ') : '';
};

export const textComposeMap = {
  font: composeFontProperty,
};
